/**
 * Model transferu danych (DTO) służący do żądania utworzenia
 * nowego zbiorczego zestawienia rozliczeń (Summary Settlement).
 * Przekazuje do API informację o tym, dla jakiej kliniki i z jakich
 * dokładnie transakcji należy wygenerować dokument podsumowujący.
 */
export class SummarySettlementDtoRequest {

  /** Identyfikator klienta, w którego kontekście wykonywana jest operacja.
   */
  public clientUUID: string;

  /** Identyfikator konkretnej placówki weterynaryjnej,
   * dla której generowane jest zestawienie.
   */
  public vetcodeId: number;

  /** Tablica identyfikatorów pojedynczych rozliczeń (OrderSettlement),
   * które system ma zagregować w nowo tworzonym raporcie.
   */
  public setttlements: string[];

}
